export default __webpack_public_path__ + "static/media/icon-tick-blue.2246a0a2.svg";